import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent, FooterComponent } from './components';
import { RouterModule } from '@angular/router';
import { LoadSpinnerComponent } from './components/load-spinner/load-spinner.component';
import { ModalShellComponent } from './components/modal-components/modal-shell/modal-shell.component';
import { ModalHeaderComponent } from './components/modal-components/modal-header/modal-header.component';
import { ModalBodyComponent } from './components/modal-components/modal-body/modal-body.component';
import { ErrorMessageComponent } from './components/error-message/error-message.component';
import { CheckboxComponent } from './components/form-components/checkbox/checkbox.component';
import { InputGroupComponent } from './components/form-components/input-group/input-group.component';
import { ConfirmationModalComponent } from './components/modal-components/confirmation-modal/confirmation-modal.component';
import { ModalFooterComponent } from './components/modal-components/modal-footer/modal-footer.component';
import { LogoComponent } from './components/svg-components/logo/logo.component';
import { TableCellDirective } from './components/tables/table-cell/table-cell.component';
import { TableHeaderDirective } from './components/tables/table-header/table-header.component';
import { TableComponent } from './components/tables/table/table.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutofocusDirective } from './directives/autofocus.directive';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    LoadSpinnerComponent,
    ModalShellComponent,
    ModalHeaderComponent,
    ModalBodyComponent,
    ModalFooterComponent,
    InputGroupComponent,
    TableComponent,
    CheckboxComponent,
    LogoComponent,
    ErrorMessageComponent,
    AutofocusDirective,
    ConfirmationModalComponent,
    TableHeaderDirective,
    TableCellDirective
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    LoadSpinnerComponent,
    ModalShellComponent,
    ModalHeaderComponent,
    ModalBodyComponent,
    ModalFooterComponent,
    InputGroupComponent,
    TableComponent,
    CheckboxComponent,
    LogoComponent,
    ErrorMessageComponent,
    AutofocusDirective,
    ConfirmationModalComponent,
    TableHeaderDirective,
    TableCellDirective
  ]
})
export class LayoutModule { }
